import React from 'react';
import Form from 'react-bootstrap/Form';

import './styles.scss';

const InputText = ({ label, maxLength, type="text", placeholder, onInput, handleChange, id, value, readOnly, disabled, error=[], otherClass}) => {

return <span>
            <div className={"input-text-container " + otherClass}>
                <Form.Group controlId={id}>
                    <Form.Label>{label}</Form.Label>
                    <Form.Control value={value} type={type} onInput={onInput} maxLength={maxLength} placeholder={placeholder} onChange={handleChange} readOnly={readOnly} disabled={disabled}/>
                </Form.Group>
            </div>
            <div className={"input-error " + otherClass}>
                {error.map(item => {
                    return <p>{item}</p>;
                })}
            </div>
    </span>
}

export default InputText;